export const TARGET_PAGE_UPDATE_OTNS_MAP = 'TARGET_PAGE_UPDATE_OTNS_MAP'
export const TARGET_PAGE_UPDATE_TAGS_MAP = 'TARGET_PAGE_UPDATE_TAGS_MAP'
export const TARGET_PAGE_UPDATE_CUFS_MAP = 'TARGET_PAGE_UPDATE_CUFS_MAP'
export const TARGET_PAGE_UPDATE_GAFS_MAP = 'TARGET_PAGE_UPDATE_GAFS_MAP'
export const TARGET_PAGE_UPDATE_CUSTOM_EVENTS_MAP = 'TARGET_PAGE_UPDATE_CUSTOM_EVENTS_MAP'
export const TARGET_PAGE_RESET_MAPS = 'TARGET_PAGE_RESET_MAPS'
